import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';

import { SharedService } from 'app/shared/shared.service';
import { API_HTTP_LOADER } from 'app/shared/interceptors/api-message-context';

@Injectable()
export class HttpLoadingInterceptor implements HttpInterceptor {
    constructor(private _sharedService: SharedService) {}

    intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        if (!this._shouldTrack(req)) {
            return next.handle(req);
        }

        this._sharedService.beginHttpLoading();

        return next.handle(req).pipe(
            finalize(() => this._sharedService.endHttpLoading()),
        );
    }

    private _shouldTrack(req: HttpRequest<unknown>): boolean {
        if (!req.context.get(API_HTTP_LOADER)) {
            return false;
        }

        return req.url.includes('/api/');
    }
}
